import { ErrorBoundary } from 'react-error-boundary';
import GlobalFallbackComponent from './GlobalFallbackComponent';
import LoggerUtil from '../../../helpers/LoggerUtil';
import { useLocalization } from '../../../providers/LocalizationProvider';

function GlobalFallbackWithLogo(props) {
  // Logo is passed via props
  const { Logo, ErrorDisplay, Footer, ...rest } = props;
  return (
    <GlobalFallbackComponent
      Logo={Logo}
      ErrorDisplay={ErrorDisplay}
      Footer={Footer}
      {...rest}
      useLocalization={useLocalization}
    />
  );
}

function ErrorBoundaryFallback(props) {
  // Logo is passed via props
  const { Logo, ErrorDisplay, ...rest } = props;
  return (
    <GlobalFallbackWithLogo {...rest} ErrorDisplay={ErrorDisplay} Logo={Logo} />
  );
}

function ErrorBoundaryFallbackWithLogo(
  Logo,
  getErrorMessage,
  ERROR_PAGE_TYPE,
  ErrorDisplay,
  Footer,
) {
  return function FallbackComponent(props) {
    return (
      <ErrorBoundaryFallback
        {...props}
        Footer={Footer}
        getErrorMessage={getErrorMessage}
        ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
        Logo={Logo}
        ErrorDisplay={ErrorDisplay}
      />
    );
  };
}

function GlobalErrorHandler({
  children,
  Logo,
  getErrorMessage,
  ERROR_PAGE_TYPE,
  ErrorDisplay,
  Footer,
}) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryFallbackWithLogo(
        Logo,
        getErrorMessage,
        ERROR_PAGE_TYPE,
        ErrorDisplay,
        Footer,
      )}
      onError={(error, errorInfo) =>
        LoggerUtil.log('GlobalErrorHandler', { error, errorInfo })
      }
      onReset={() => {
        window.location.reload();
      }}>
      {children}
    </ErrorBoundary>
  );
}

export default GlobalErrorHandler;
